import { createRouter, createWebHistory } from "vue-router";
import Pricing from "../views/PricingDetails.vue";

const routes = [
  {
    path: "/",
    name: "pricing",
    component: Pricing,
    meta: {
      title: "Pricing details | Quizzr",
    },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/PrivacyPage.vue"),
    meta: {
      title: "Privacy policy | Quizzr",
    },
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("../views/TermsPage.vue"),
    meta: {
      title: "Terms and conditions | Quizzr",
    },
  },
  {
    path: "/refund",
    name: "refund",
    component: () => import("../views/RefundPage.vue"),
    meta: {
      title: "Cancellation/Refund policy | Quizzr",
    },
  },

  {
    path: "/contactus",
    name: "contact-us",
    component: () => import("../views/ContactUs.vue"),
    meta: {
      title: "Contact Us | Quizzr",
    },
  },

  {
    path: "/aboutus",
    name: "about-us",
    component: () => import("../views/AboutUs.vue"),
    meta: {
      title: "About us | Quizzr",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Quizzr";
  next();
});

export default router;
